import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

export const storageTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getStorageTypesList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.storageTypes }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getStorageTypesById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.storageTypes }/${ id }`,
		method: 'GET',
	  }),
	}),

	addStorageTypes: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.storageTypes }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editStorageTypes: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.storageTypes }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteStorageTypes: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.storageTypes }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddStorageTypesMutation,
  useDeleteStorageTypesMutation,
  useEditStorageTypesMutation,
  useGetStorageTypesByIdQuery,
  useGetStorageTypesListQuery,
  useLazyGetStorageTypesListQuery
} = storageTypesApi;
